import React from 'react'
import ContactItem from '../contact-item'
import Icon from '../icon'
import styles from './Footer.module.css'

const email = 'mayurpankhevents@gmail.com'
const phoneNumber = '8800341266'

const Footer = () => {
  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <section className={styles.gridContainer}>
          <section>
            <h4 className={styles.title}>Contact</h4>
            <div className={styles.contactDetails}>
              <ContactItem name="email" value={email}></ContactItem>
              <ContactItem name="telephone" value={phoneNumber}></ContactItem>
              <ContactItem
                name="address"
                value="Delhi"
                isLink={false}
              ></ContactItem>
            </div>
          </section>

          <section>
            <h4 className={styles.title}>Social media</h4>
            <div className={styles.socialButtons}>
              <a
                className={styles.socialLink}
                href="https://www.facebook.com/Mayurpankh-Events-864130967075137/"
                target="_blank"
                rel="noopener"
              >
                <Icon name="facebook"></Icon>
                Facebook
              </a>

              <a
                className={styles.socialLink}
                href="https://www.youtube.com/channel/UCta34xSFpcUnxjwbCUIQaOA"
                target="_blank"
                rel="noopener"
              >
                <Icon name="youtube"></Icon>
                Youtube
              </a>
            </div>
          </section>
        </section>

        <div className={styles.copyrightContainer}>
          Copyright © {new Date().getFullYear()} Mayurpankh Events
        </div>
      </div>
    </footer>
  )
}

export default Footer
